const FilterSheet = () => {
    return {
        open: false,
        isResizing: false,
        seeMore: false,
        pagePosition: 0,

        init() {
            this.$watch('open', value => {
                document.getElementById('content-list').style.touchAction = value ? 'none' : 'auto';

                this.adjustPanelHeight();
            });
        },

        getScrollPositionWithinDocumentBounds() {
            const maximumScrollPosition = document.documentElement.scrollHeight - window.innerHeight;

            return Math.min(Math.max(window.scrollY, 0), Math.max(maximumScrollPosition, 0));
        },

        repositionFilterBar() {
            const style               = window.getComputedStyle(this.$el);
            const currentPagePosition = this.getScrollPositionWithinDocumentBounds();
            const scrolled            = currentPagePosition - this.pagePosition;

            let newPosition = Math.max(parseInt(style.bottom) + scrolled, -53);

            newPosition = Math.min(newPosition, 0);

            this.pagePosition = currentPagePosition;

            this.$el.style.bottom = `${newPosition}px`;
        },

        showSeeMoreButton(newComputedHeight) {
            const demographicRect = this.$refs.demographicFilters.getBoundingClientRect();
            const subjectRect     = this.$refs.subjectFilters.getBoundingClientRect();

            this.seeMore = demographicRect.height + subjectRect.height + 11 > newComputedHeight;
        },

        adjustPanelHeight() {
            if (window.innerWidth >= 1280) {
                this.open = false;
            }

            if (!this.open) {
                return;
            }

            this.$nextTick(() => {
                this.$refs.filtersContainer.scrollTo(0, 0);

                const filtersRect = this.$refs.filtersContainer.getBoundingClientRect();

                const newComputedHeight = Math.min(filtersRect.height, 276);

                this.$refs.filtersContainer.style.height = newComputedHeight + 'px';

                this.showSeeMoreButton(newComputedHeight);
            });
        },

        resizePanel() {
            if (this.isResizing) {
                const resizerRect = this.$el.getBoundingClientRect();
                const filtersRect = this.$refs.filtersContainer.getBoundingClientRect();

                const event = this.$event.touches ? this.$event.touches[0] : this.$event;

                let newComputedHeight = filtersRect.height - (event.clientY - resizerRect.top);

                newComputedHeight = Math.min(newComputedHeight, window.innerHeight - 113);
                newComputedHeight = Math.max(newComputedHeight, 168);

                this.$refs.filtersContainer.style.height = newComputedHeight + 'px';

                this.showSeeMoreButton(newComputedHeight);
            }
        },

        clearAllFilters() {
            this.demographic      = this.temp_demographic       = 'none';
            this.demographicTitle = this.temp_demographic_title = '';

            this.setFilter('subject', 'none', '');

            this.open = false;
        },

        toggleSeeMore() {
            const subjectRect     = this.$refs.subjectFilters.getBoundingClientRect();
            const demographicRect = this.$refs.demographicFilters.getBoundingClientRect();

            const newComputedHeight = demographicRect.height + subjectRect.height + 12;

            this.$refs.filtersContainer.style.height = newComputedHeight + 'px';

            this.seeMore = !this.seeMore;
        },

        applyFilters() {
            this.demographic      = this.temp_demographic;
            this.demographicTitle = this.temp_demographic_title;

            this.subject      = this.temp_subject;
            this.subjectTitle = this.temp_subject_title;

            this.setUrl();

            this.$dispatch('reset-page');

            this.open = false;
        },

        setTempFilter(tempType, slug, title) {
            this[tempType] = this[tempType] === slug ? 'none' : slug;

            this[tempType + '_title'] = this[tempType] === 'none' ? '' : title;
        },

        resetTempFilters() {
            this.open                   = false;
            this.temp_subject           = this.subject;
            this.temp_demographic       = this.demographic;
            this.temp_subject_title     = this.subjectTitle;
            this.temp_demographic_title = this.demographicTitle;
        },
    };
};

export default FilterSheet;
